import React, { useEffect } from 'react';
import { Link, useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

import MaterialTable from 'material-table'

import CouplePickerDialog from '../CouplePickerDialog';
import PaymentCreateDialog from './PaymentCreateDialog';
import PaymentEmailDialog from './PaymentEmailDialog';
import ConfirmDialog from '../ConfirmDialog';


const tableRef = React.createRef();

const dateKeys = {
    start: 'enduringpromises.com.payments.table.dates.start',
    end: 'enduringpromises.com.payments.table.dates.end',
    type: 'enduringpromises.com.payments.table.dates.type',
};
const sessionKeys = {
    search: 'enduringpromises.com.payments.table.search'
};

const useStyles = makeStyles(theme => ({
    formField: {
      marginLeft: theme.spacing(2),
    },
    formButton: {
        marginLeft: theme.spacing(1),
    },
    paper: {
        padding: theme.spacing(3),
    },
    link: {
        color: theme.palette.primary.dark,
    }
}));

const MaterialTableTable = (props) => {
    const {
        dateStart,
        dateEnd,
        dateFilterType,
    } = props;

    const classes = useStyles();

    const formatNumber = (number) => {
        return (number !== '' && number !== undefined) ? parseFloat(number).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        }) : '';
    }

    const provinces = window.provinces;
    const [state, setState] = React.useState({
        columns: [
            {
                title: 'Payment #',
                render: rowData => (
                    <div>
                        #{rowData.payment_number}
                    </div>
                )
            },
            {
                title: 'Couple',
                render: rowData => (
                    <div>
                        {rowData.wedding && (
                            <Link className={classes.link} to={`/admin/couples/${rowData.wedding.id}`}>
                                {rowData.wedding.bride_full_name} and {rowData.wedding.groom_full_name}
                            </Link>
                        )}
                    </div>
                )
            },
            { title: 'Wedding Date', field: 'wedding.wedding_date_formatted', type: 'date' },
            {
                title: 'Officiant',
                render: rowData => {
                    return rowData.wedding && rowData.wedding.officiant ? (
                        <div>
                            {rowData.wedding.officiant.name}
                        </div>
                    ) : '';
                }
            },
            {
                title: 'Province',
                render: rowData => {
                    if (!rowData.wedding) { return ''; }
                    const province = provinces.filter(i => i.id == rowData.wedding.couple_province_id)[0];
                    return province ? (
                        <div><span title={province.province_name}>{province.province_code}</span></div>
                    ) : '';
                }
            },
            { title: 'Date Received', field: 'date_received_formatted', type: 'date' },
            { title: 'Amount', field: 'amount', type: 'currency' },
            {
                title: 'Balance',
                field: 'wedding.balance',
                type: 'currency',
                render: rowData => {
                    if (!rowData.wedding) { return ''; }
                    return (
                        <Link className={classes.link} to={`/admin/balances/${rowData.wedding.id}`}>
                            {formatNumber(rowData.wedding.balance)}
                        </Link>
                    )
                }
            },
        ],
    });

    /* TODO: Make balance link to balance detail for couple */

    const pageSizeOptions = [10, 30, 50, 100, 250];

    const fetchData = query =>
        new Promise((resolve, reject) => {
            let url = '/api/payments?';

            /* set the search to local storage */
            localStorage.setItem(sessionKeys.search, query.search);

            /* TOOD: find better way to do this */
            query.dateStart = query.dateStart ? query.dateStart : dateStart;
            query.dateEnd = query.dateEnd ? query.dateEnd : dateEnd;

            /* TODO: use orderBy and filters */
            url += 'per_page=' + query.pageSize
            url += '&page=' + (query.page + 1)
            url += '&search=' + query.search
            url += '&orderBy=' + (query.orderBy ? query.orderBy.field : '')
            url += '&orderDirection=' + query.orderDirection
            url += '&dateStart=' + dateFormatter(query.dateStart);
            url += '&dateEnd=' + dateFormatter(query.dateEnd);
            url += '&dateFilterType=' + dateFilterType;
            if (query.filters.length) {
                url += '&' + query.filters.map(x => `${x.column.field}=`+encodeURI(x.value)).join('&')
            }
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    tableRef.current.props.options.pageSizeOptions = pageSizeOptions;
                    resolve({
                        data: result.data,
                        page: result.current_page - 1,
                        totalCount: result.total,
                    })
                })
            }
        )

    let history = useHistory();

    function handleEditPayment(event, rowData) {
        history.push(`/admin/payments/${rowData.id}`);
    }

    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState('');
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const [selected, setSelected] = React.useState({});

    const [emailDialogOpen, setEmailDialogOpen] = React.useState(false);
    const handleEmail = rowData => {
        setSelected(rowData);
        setEmailDialogOpen(true);
    }

    /* related to delete payment action */
    const deletePayment = selected => {
        const data = { _token: window._token };
        new Promise((resolve, reject) => {
            let url = `/api/payments/${selected.id}`;
            fetch(url, {
                method: 'DELETE',
                body: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setSnackbarMessage('Payment was successfully deleted');
                    setOpenSnackbar(true);
                    resolve();
                })
                .catch(reason => {
                    alert('An error prevented deleting the payment. Please refresh the page and try again.');
                })
        });
    }
    const [deleteConfirmText, setDeleteConfirmText] = React.useState('Are you sure you wish to delete this payment?');
    const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
    const handleCloseDialog = action => () => {
        if (action == 'agree') {
            deletePayment(selected);
            tableRef.current && tableRef.current.onQueryChange()
        }
        setConfirmDialogOpen(false);
    };
    const handleDelete = rowData => {
        setSelected(rowData);
        setDeleteConfirmText(`Are you sure you wish to delete payment #${rowData.payment_number}?`);
        setConfirmDialogOpen(true);
    }

    const defaultSearchText = localStorage.getItem(sessionKeys.search) || '';

    return (
        <React.Fragment>
            <MaterialTable
                title="Payments List"
                columns={state.columns}
                data={fetchData}
                actions={[
                    {
                        icon: 'edit',
                        tooltip: 'Edit Payment',
                        onClick: handleEditPayment
                    },
                    {
                        icon: 'delete',
                        tooltip: 'Delete Payment',
                        onClick: (event, rowData) => {
                            handleDelete(rowData);
                        }
                    },
                    {
                        icon: 'email',
                        tooltip: 'Email Payment',
                        onClick: (event, rowData) => {
                            handleEmail(rowData);
                        }
                    },
                    {
                        icon: 'refresh',
                        tooltip: 'Refresh Data',
                        isFreeAction: true,
                        onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                    }
                ]}
                components={{
                    Container: Box,
                }}
                options={{
                    showTitle: false,
                    pageSize: 10,
                    pageSizeOptions: pageSizeOptions,
                    exportButton: true,
                    loadingType: 'linear',
                    emptyRowsWhenPaging: false,
                    sorting: false,
                    debounceInterval: 600,
                    padding: 'dense',
                    searchText: defaultSearchText,
                }}
                tableRef={tableRef}
            />
            <PaymentEmailDialog
                open={emailDialogOpen}
                selected={selected}
                setOpen={setEmailDialogOpen}
                setSnackbarMessage={setSnackbarMessage}
                setOpenSnackbar={setOpenSnackbar}
            />
            <ConfirmDialog
                title="Confirm delete"
                text={deleteConfirmText}
                agreeText="Delete"
                declineText="Cancel"
                handleClose={handleCloseDialog}
                open={confirmDialogOpen}
                setOpen={setConfirmDialogOpen}
                agreeColor="secondary"
            />
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                message={snackbarMessage}
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />
        </React.Fragment>
    );
};

const dateFormatter = date => {
    return [
        date.getFullYear(), date.getMonth()+1, date.getDate()
    ].join('-');
}

const PaymentDatePicker = (props) => {
    const {
        dateStart,
        dateEnd
    } = props;

    const [selectedStartDate, setselectedStartDate] = React.useState(dateStart);
    const [selectedEndDate, setSelectedEndDate] = React.useState(dateEnd);
    const classes = useStyles();

    const handleDateChange = date => {
        setselectedStartDate(date);
    };

    const handleEndDateChange = date => {
        setSelectedEndDate(date);
    };

    const handleDateSet = () => {
        localStorage.setItem(dateKeys.start, selectedStartDate);
        localStorage.setItem(dateKeys.end, selectedEndDate);
        if (tableRef.current) {
            const query = tableRef.current.state.query;
            query.dateStart = selectedStartDate;
            query.dateEnd = selectedEndDate;
            query.page = 0;
            tableRef.current.onQueryChange();
        }
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="baseline"
            >
                <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="Date filter"
                    helperText="Start Date"
                    format="MM/dd/yyyy"
                    value={selectedStartDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                />
                <KeyboardDatePicker
                    margin="normal"
                    id="date-end-picker-dialog"
                    format="MM/dd/yyyy"
                    helperText="End Date"
                    value={selectedEndDate}
                    onChange={handleEndDateChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    className={classes.formField}
                />
                <Button className={classes.formButton} onClick={handleDateSet}>Set</Button>
            </Grid>
        </MuiPickersUtilsProvider>
    );
};

const PaymentList = () => {
    const classes = useStyles();

    useEffect(() => {
        document.title = 'Payments - Enduring Promises';
    });

    const [couple, setCouple] = React.useState({});
    const [payment, setPayment] = React.useState({});

    /* State for PaymentCreateDialog */
    const [paymentDialogOpen, setPaymentDialogOpen] = React.useState(false);
    const closePaymentCreateDialog = event => {
        setPaymentDialogOpen(false);
        tableRef.current && tableRef.current.onQueryChange();
    };

    /* State for CouplePickerDialog */
    const [couplePickerDialogOpen, setCouplePickerDialogOpen] = React.useState(false);
    const openCouplePickerDialog = () => {
        setCouplePickerDialogOpen(true);
    };
    const closeCouplePickerDialog = () => {
        setCouplePickerDialogOpen(false);
    };

    const handleNextButtonClick = couple => {
        setCouple(couple);
        setPayment({
            comments: '',
            amount: 0,
            invoice_id: null,
        });
        setPaymentDialogOpen(true);
    }

    const defaultDateStart = localStorage.getItem(dateKeys.start) ? new Date(localStorage.getItem(dateKeys.start)) : new Date(new Date().setMonth(new Date().getMonth() - 2));
    const defaultDateEnd = localStorage.getItem(dateKeys.end) ? new Date(localStorage.getItem(dateKeys.end)) : new Date();
    const defaultFilterType = localStorage.getItem(dateKeys.type) ? localStorage.getItem(dateKeys.type) : 'date_received';
    localStorage.setItem(dateKeys.start, defaultDateStart);
    localStorage.setItem(dateKeys.end, defaultDateEnd);
    localStorage.setItem(dateKeys.type, defaultFilterType);

    const [dateStart, setDateStart] = React.useState(defaultDateStart);
    const [dateEnd, setDateEnd] = React.useState(defaultDateEnd);

    const [dateFilterState, setDateFilterState] = React.useState(defaultFilterType);
    const handleFilterChange = (event) => {
        const value = event.target.value;
        localStorage.setItem(dateKeys.type, value);
        setDateFilterState(value);
    }

    return (
        <Paper square className={classes.paper}>
            <div style={{ maxWidth: '100%' }}>
                <Typography variant="h6">Payments</Typography>
                <Grid
                    container
                    spacing={2}
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                >
                    <Grid item xs={12} sm={12} md={8} style={{maxWidth: 580}}>
                        <Box mt={2}>
                            <TextField
                                id="date-filter-type"
                                select
                                onChange={handleFilterChange}
                                label="Filter date by"
                                value={dateFilterState}
                                SelectProps={{
                                    autoWidth: true
                                }}
                            >
                                <MenuItem value='date_received'>Date Received</MenuItem>
                                <MenuItem value='wedding_date'>Wedding Date</MenuItem>
                            </TextField>
                        </Box>
                        <PaymentDatePicker dateStart={dateStart} dateEnd={dateEnd} />
                    </Grid>
                    <Grid item xs={12} sm md style={{textAlign: 'right', minWidth: 142}}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={openCouplePickerDialog}
                        >
                            Add Payment
                        </Button>
                    </Grid>
                </Grid>
                <MaterialTableTable dateStart={dateStart} dateEnd={dateEnd} dateFilterType={dateFilterState} />
                <CouplePickerDialog
                    open={couplePickerDialogOpen}
                    handleClose={closeCouplePickerDialog}
                    handleNextButtonClick={handleNextButtonClick}
                />
                <PaymentCreateDialog
                    open={paymentDialogOpen}
                    handleClose={closePaymentCreateDialog}
                    payment={payment}
                    couple={couple}
                    scroll='paper'
                />
            </div>
        </Paper>
    )
}

export default PaymentList;
